import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_VOICE, FRAGMENT_BRAND_VOICE_ASSETS } from './schema';

const MUTATION = gql`
  mutation CreateBrandVoice($name: String!, $customerId: ID!, $workspaceId: ID, $language: String) {
    createBrandVoice(
      name: $name
      customerId: $customerId
      workspaceId: $workspaceId
      language: $language
    ) {
      ...BrandVoice
      ...BrandVoiceAssets
    }
  }
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_BRAND_VOICE_ASSETS}
`;

export const createBrandVoice = ({ name, customerId, workspaceId, language }) => {
  const variables = {
    name,
    customerId,
    workspaceId,
    language,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
